export const vw: number = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
export const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);